<template>
  <div class="v-user-table">
    <v-user-create-update-form v-if="this.isShowModal"
                                 :user-id="this.currentUserId"
                                 @close="closeModal" />
    <table class="table">
      <thead>
        <tr>

          <th v-if="$router.currentRoute.path === '/employees'" scope="col">Сотрудник</th>
          <th v-else-if="$router.currentRoute.path === '/subscribers'" scope="col">Подписчик</th>
          <th v-else-if="$router.currentRoute.path === '/dealers'" scope="col">Дилер</th>

          <th v-if="$router.currentRoute.path !== '/employees'">Баланс</th>

          <th v-if="$router.currentRoute.path === '/dealers'" scope="col">SIM карты</th>

          <th v-if="$router.currentRoute.path === '/dealers'" scope="col">Тарифы</th>
          <th v-else>Статус</th>

          <th v-if="$router.currentRoute.path === '/dealers'" scope="col">Подписки</th>

          <th scope="col">Активность</th>
          <th scope="col"></th>
          <th scope="col" v-if="role === 'administrator'"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="user in this.userList.results" :key="user.id">

          <th>
              {{ user.first_name }} {{ user.last_name }}
          </th>

          <td v-if="$router.currentRoute.path !== '/employees'">{{ user.balance }}</td>

          <td v-if="$router.currentRoute.path === '/dealers'">{{ user.sim_cards }}</td>
          <td v-if="$router.currentRoute.path === '/dealers'">{{ user.tariffs }}</td>
          <td v-else>{{ user.is_active ? 'Активен' : 'Не активен' }}</td>
          <td v-if="$router.currentRoute.path === '/dealers'">{{ user.subscriptions }}</td>

          <td v-if="user.last_login">{{ fixDate(user.last_login) }}</td>
          <td v-else>Новый</td>
          <td @click="showModal(user.id)">
            <font-awesome-icon :icon="['fa', 'cogs']"/>
          </td>
          <td v-if="role === 'administrator'"  @click="deleteUser(user.id)">
            <font-awesome-icon :icon="['fa', 'trash']"/>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import * as moment from 'moment/moment';
import VUserCreateUpdateForm from '../forms/v-user-create-update-form.vue';

export default {
  name: 'v-user-table',
  components: { VUserCreateUpdateForm },
  props: ['userList', 'role'],
  data() {
    return {
      currentUserId: '',
      isShowModal: false,
    };
  },
  methods: {
    showModal(userId) {
      this.isShowModal = true;
      this.currentUserId = userId;
    },
    closeModal() {
      this.isShowModal = false;
      this.$emit('update');
    },
    fixDate(event) {
      return moment(event).format('DD-MM-YY');
    },
    deleteUser(userID) {
      this.$modal.show('dialog', {
        title: 'Внимание!',
        text: 'Вы действительно хотите удалить этого пользователя?',
        buttons: [
          {
            title: 'Удалить пользователя',
            handler: () => {
              this.$store.dispatch('user/deleteUser', userID)
                .then(() => {
                  this.$emit('update');
                  this.$modal.hide('dialog');
                });
            },
          },
          {
            title: 'Закрыть',
            default: true,
          },
        ],
      });
    },
  },
};
</script>
